/* eslint-disable new-cap */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/media-has-caption */
import { CloseCircleOutlined } from "@ant-design/icons";
import { message } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import RecorderPauseIcon from "../../../icons/js/EditorIcons/RecordingIcons/PauseIcon";
import RecorderResumeIcon from "../../../icons/js/EditorIcons/RecordingIcons/ResumeIcon";
import RecorderStopIcon from "../../../icons/js/EditorIcons/RecordingIcons/StopIcon";
import { MicIosFilled } from "../../../icons/js/MicIosIcon";

export function AudioRecorder({
  setAudioUrl,
  setaudioBlob,
  editorRef,
  setcontent,
  isRecording: externalIsRecording,
  setIsRecording: externalSetIsRecording,
  stopRecordingRef,
}) {
  const mediaRecorderRef = useRef(null);
  const recognitionRef = useRef(null);
  const audioChunksRef = useRef([]);
  const intervalRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [interimTranscript, setInterimTranscript] = useState("");
  const [showRecording, setshowRecording] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const [recordingTime, setRecordingTime] = useState(0);

  // Use external state if provided, otherwise use internal state
  const isRecordingState = externalIsRecording !== undefined ? externalIsRecording : isRecording;
  const setIsRecordingState = externalSetIsRecording || setIsRecording;
  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      mediaRecorderRef.current.ondataavailable = event => {
        audioChunksRef.current.push(event.data);
      };
      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: "audio/wav" });
        const url = URL.createObjectURL(audioBlob);
        if (showRecording) setAudioUrl(prev => [...prev, url]);
        audioChunksRef.current = [];

        // Resolve the promise if it exists
        if (mediaRecorderRef.current.stopPromiseResolve) {
          mediaRecorderRef.current.stopPromiseResolve();
          mediaRecorderRef.current.stopPromiseResolve = null;
        }
      };
      mediaRecorderRef.current.start();
      recognitionRef.current.start();
      setIsRecordingState(true);
      intervalRef.current = setInterval(() => {
        setRecordingTime(prevTime => prevTime + 1);
      }, 1000);
    } catch (error) {
      console.error("Error accessing microphone:", error);
      // Optionally show a user-friendly error message
      message.error("Microphone access was denied. Please enable microphone permissions.");
      setIsRecordingState(false);
    }
  };

  const handleStopRecording = () => {
    return new Promise(resolve => {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        // Store the resolve function to be called in onstop
        mediaRecorderRef.current.stopPromiseResolve = resolve;
        mediaRecorderRef.current.stop();
      } else {
        resolve();
      }

      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
      setIsRecordingState(false);
      clearInterval(intervalRef.current);
      setRecordingTime(0);
      setIsPaused(false);
    });
  };

  // Expose stop function to parent via ref
  useEffect(() => {
    if (stopRecordingRef) {
      stopRecordingRef.current = handleStopRecording;
    }
  }, [stopRecordingRef]);
  const handlePauseRecording = () => {
    if (isPaused) {
      mediaRecorderRef.current.resume();
      intervalRef.current = setInterval(() => {
        setRecordingTime(prevTime => prevTime + 1);
      }, 1000);
    } else {
      mediaRecorderRef.current.pause();
      clearInterval(intervalRef.current);
    }
    setIsPaused(!isPaused);
  };
  const handleRecognitionResult = event => {
    let interimTranscript = "";
    for (let i = event.resultIndex; i < event.results.length; i++) {
      const transcriptPart = event.results[i][0].transcript;
      if (event.results[i].isFinal) {
        interimTranscript += `${transcriptPart} `;
      }
    }

    setInterimTranscript(interimTranscript);
  };
  useEffect(() => {
    if (editorRef.current && interimTranscript) {
      const content = `${editorRef.current.innerHTML} ${interimTranscript}`;
      editorRef.current.innerHTML = content;
    }
  }, [interimTranscript]);
  useEffect(() => {
    if (
      !navigator.mediaDevices ||
      !window.MediaRecorder ||
      (!window.SpeechRecognition && !window.webkitSpeechRecognition)
    ) {
      console.error(
        "Your browser does not support the required APIs for audio recording and transcription."
      );
      return;
    }
    recognitionRef.current = new webkitSpeechRecognition();
    recognitionRef.current.continuous = true;
    recognitionRef.current.interimResults = true;
    recognitionRef.current.lang = "en-US";
    recognitionRef.current.onresult = handleRecognitionResult;
    recognitionRef.current.onend = () => {
      if (editorRef.current) {
        setcontent(`${editorRef.current.innerHTML} ${interimTranscript}`);
      }
    };
    recognitionRef.current.onnomatch = err => message.error("Cannot recognize this speech!!");
    recognitionRef.current.onerror = event =>
      console.error("Speech Recognition error:", event.error);
    // recognitionRef.current.addEventListener("result", handleRecognitionResult);

    return () => {
      clearInterval(intervalRef.current);
      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
    };
  }, []);
  const formatTime = time => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    if (minutes === 0) {
      return `${seconds}${seconds === 1 ? "s" : "s"}`;
    }
    return `${minutes}${minutes === 1 ? "m" : "m"} ${seconds}${seconds === 1 ? "s" : "s"}`;
  };
  return isRecordingState ? (
    <div className="flex-row-centered gap-2">
      {isPaused ? (
        <RecorderResumeIcon className="cursor-pointer" onClick={handlePauseRecording} />
      ) : (
        <RecorderPauseIcon className="cursor-pointer" onClick={handlePauseRecording} />
      )}
      <RecorderStopIcon
        className="cursor-pointer"
        onClick={() => {
          handleStopRecording();
          //   handleInsert();
        }}
      />
      <span className="text-xs font-[400] text-grey-700">
        {formatTime(recordingTime)} recording
      </span>
      <CloseCircleOutlined
        onClick={() => {
          setshowRecording(false);
          handleStopRecording();
        }}
        className="text-grey-700 cursor-pointer"
      />
    </div>
  ) : (
    <span
      onClick={handleStartRecording}
      className="px-2 cursor-pointer flex-row-centered text-xs font-[400] gap-1 py-1 rounded-[38px] border border-solid border-brand-500 text-brand-500"
    >
      <MicIosFilled />
      Record & Dictate
    </span>
  );
}
